import Vue from 'vue';
import routers from '@/router/routers';
import {
    localToken,
    cache,
    toolFunc
} from "@/libs/func";
import globConfig from "@/config/config";
import wxJsSdk from "@/libs/wxJssdk.ac";
//import wx from 'weixin-jsapi'
//前置操作 检测用户是否登录等 未登录通过oauth页面进行登录
routers.beforeEach((to, from, next) => {
    /// star
    let toQuery = JSON.parse(JSON.stringify(to.query));
    if (from.query.mp) {
        toQuery.mp = from.query.mp;
    }
    if (to.query.mp) {
        toQuery.mp = to.query.mp;
    };
    localToken.setMp(toQuery.mp);
    /// end
    let tenant = localToken.getTenant()
    let title = '云会员中心'
    if (tenant && JSON.parse(tenant).tenantName) {
        title = JSON.parse(tenant).tenantName
    }
    document.title = title // + (to.meta.title ? ('-' + to.meta.title) : '')
    document.title2 = title + (to.meta.title ? ('-' + to.meta.title) : '')
    console.log(routers)
    let that = this;
    //调试用
    //toolFunc.jumpToMp('/Oauth');
    //没有任何mp信息
    if (!to.query.mp && !from.query.mp) {
        //跳转错误
        if (to.path === '/ErrorPage/Error') {
            next();
            return;
        }
        next('/ErrorPage/Error');
        return;
    }
    /// star
    // let toQuery = JSON.parse(JSON.stringify(to.query));
    // if (from.query.mp) {
    //     toQuery.mp = from.query.mp;
    // }
    // if (to.query.mp) {
    //     toQuery.mp = to.query.mp;
    // };
    // localToken.setMp(toQuery.mp);
    let access_token = localToken.get(); // 获取登陆token
    /// end
    //如果是到推荐中转页面直接前往会员中心(如果是未注册会员回到注册页面)
    if(to.path.indexOf('/RefereeTrans') !== -1 ) {
      //设置推荐码 如果有其他的继续设置 不过要记得在用完时候 清除掉
      let refereeCode = toQuery.referee || '';
      cache.set(globConfig.refereeCodeName, refereeCode, 1800);  //设置成半个小时有效期就行了
      //门店id 注册
      let shopId = toQuery.deptId || '';
      cache.set(globConfig.refereeShopIdName, shopId, 1800);
      //门店id 充值
      let rechargeShopId = toQuery.rechargeDeptId || '';
      cache.set(globConfig.rechargeShopIdCacheName, rechargeShopId, 1800);
      //门店充值 直接跳转充值页面 //如果未注册 会自动跳转到注册
      if(rechargeShopId) {
        next({
          path: '/Member/Recharge',
          //query: toQuery
          query: {
            mp: toQuery.mp
          }
        });
        return false;
      }

      //其他直接跳转到会员中心首页
      next({
        path: '/Member',
        //query: toQuery
        query: {
          mp: toQuery.mp
        }
      });
      return false;
    }

    //token无效 前往oauth
    if (!access_token) { //token不存在

        if (to.path !== '/Oauth') { //如果进入的非oauth页面
            // 如果进入绑定手机号页面
            if (to.path === '/Register') {
                if (cache.get(globConfig.registerTokenName)) { //存在注册token 直接跳转
                    //没有带mp的url必须带上mp toQuery中是肯定存在mp的
                    if (!to.query.mp) {
                        next({
                            path: to.path,
                            query: toQuery
                        });
                        return;
                    }
                    next();
                    return true;
                }
            } else if (to.path === '/ErrorPage/Error') {
                // if (cache.get(globConfig.registerTokenName)) { //存在注册token 直接跳转
                //没有带mp的url必须带上mp toQuery中是肯定存在mp的
                if (!to.query.mp) {
                    next({
                        path: to.path,
                        query: toQuery
                    });
                    return;
                }
                next();
                return true;
            } else {
                //记录 登录成功后的跳转页面
                localStorage.setItem(globConfig.redirectKey, to.fullPath);
            }
            next({
                path: '/Oauth',
                query: toQuery
            });
            return false;
        }
    }

    //以下步骤已然可以正常的进入页面


    /******** 全局注入微信jssdk start ********/

    //不支持获取sdk参数的路径 因为没有正常业务token获取不到 签名
    let $eliminatePathArr = ['/Oauth', '/Register'];
    if ($eliminatePathArr.indexOf(to.path) === -1) {
        //这里点击页面会执行两次 原因暂时未知 不过已经被我机智的拦截了
        Vue.nextTick(() => {
            wxJsSdk.registerEvent();
        });
    }
    /******** 全局注入微信jssdk end ********/


    //没有带mp的url必须带上mp toQuery中是肯定存在mp的
    if (!to.query.mp) {
        next({
            path: to.path,
            query: toQuery
        });
        return;
    }
    next();
});




export default routers;



// WEBPACK FOOTER //
// ./src/router/index.js